module.exports = __webpack_public_path__ + "static/media/concept-8-sm-3.c9f1a582.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/union-square/concept-8-sm-3.jpg
// module id = 4465
// module chunks = 13